import { createSlice } from "@reduxjs/toolkit";
import {
  loadSingleTrainingPeriod,
  addTrainingPeriod,
  updateTrainingPeriod,
  deleteTrainingPeriod,
} from "../actions/trainingPeriodActions";
import TrainingPeriod from "../types/TrainingPeriod";

// State Definition
interface TrainingPeriodsState {
  trainingPeriods: TrainingPeriod[];
  selectedTrainingPeriod: TrainingPeriod | null;
  loading: boolean;
  error: string | null;
}

const initialState: TrainingPeriodsState = {
  trainingPeriods: [],
  selectedTrainingPeriod: null,
  loading: false,
  error: null,
};

// Reducer
const trainingPeriodsSlice = createSlice({
  name: "trainingPeriods",
  initialState,
  reducers: {}, // Empty reducers, async handled in extraReducers
  extraReducers: (builder) => {
    builder
      // Load Single Training Period
      .addCase(loadSingleTrainingPeriod.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadSingleTrainingPeriod.fulfilled, (state, action) => {
        console.log("Reducer - Fulfilled action received:", action);
        state.selectedTrainingPeriod = action.payload;
        state.loading = false;
      })
      .addCase(loadSingleTrainingPeriod.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to load training period.";
      })

      // Add Training Period
      .addCase(addTrainingPeriod.fulfilled, (state, action) => {
        state.trainingPeriods.push(action.payload);
      })

      // Update Training Period
      .addCase(updateTrainingPeriod.fulfilled, (state, action) => {
        const index = state.trainingPeriods.findIndex((p) => p.id === action.payload.id);
        if (index !== -1) {
          state.trainingPeriods[index] = action.payload;
        }
      })

      // Delete Training Period
      .addCase(deleteTrainingPeriod.fulfilled, (state, action) => {
        state.trainingPeriods = state.trainingPeriods.filter((p) => p.id !== action.payload);
      });
  },
});

// Export Reducer
export default trainingPeriodsSlice.reducer;
